<template>
  <b-modal :active="show" @close="requestClose" :width="620">
    <div class="modal-card" style="padding-bottom:3rem">
      <div class="modal-card-head">
        <div class="modal-card-title">Wertgutschein anlegen</div>
      </div>
      <div class="modal-card-body" style="overflow-y:scroll !important;">
        <b-field label="Anzeigename" horizontal>
          <b-input
            v-model="issue.displayName"
            :lazy="true"
            required
            placeholder="Anzeigename"
          ></b-input>
        </b-field>
        <b-field label="Betrag in €" horizontal>
          <b-input
            type="number"
            icon="euro-sign"
            v-model="issue.initialValue"
            min="1"
          ></b-input>
        </b-field>
        <b-field label="Gültig bis" horizontal>
          <b-datetimepicker
            placeholder="Gültigkeit wählen"
            required
            v-model="issue.validUntil"
            horizontal-time-picker
          ></b-datetimepicker>
        </b-field>
      </div>
      <footer class="modal-card-foot">
        <b-button type="is-text" @click="cancel" expanded>Abbrechen</b-button>
        <b-button
          type="is-primary"
          :disabled="!valid"
          @click="issueGiftCard"
          expanded
          >Speichern</b-button
        >
      </footer>
    </div>
    <b-loading
      :is-full-page="false"
      :active.sync="loading"
      :can-cancel="false"
    ></b-loading>
  </b-modal>
</template>

<script>
import giftcardApi from '@/api/giftcard-api'
export default {
  name: 'CreateGiftCardModal',
  props: {
    type: String,
    show: Boolean,
  },
  computed: {
    valid() {
      if (this.issue.displayName === '') {
        return false
      }
      if (this.issue.initialValue <= 0) {
        return false
      }
      return true
    },
  },
  data() {
    return {
      loading: false,
      issue: {
        validUntil: new Date(
          new Date().setFullYear(new Date().getFullYear() + 1),
        ),
        displayName: '',
        currency: 'EUR',
        initialValue: 0,
      },
    }
  },
  async mounted() {},
  methods: {
    async issueGiftCard() {
      this.loading = true
      try {
        const res = await giftcardApi.issueGiftCard(this.issue)
        this.loading = false
        this.$emit('close', res)
      } catch {
        this.$buefy.toast.open('Bitte prüfen Sie Ihre Eingaben!')
      }
      this.loading = false
    },
    cancel() {
      this.$emit('close')
    },
    requestClose() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss">
.modal-content {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.modal-card,
.modal-content {
  width: auto;
}

.modal,
.modal-card,
.modal-card-body,
.modal-content {
  overflow: visible !important; //to show datepicker on desktop
}
</style>
